/**
 * Borvidék   * HUNGARY - Magyarország   * ABROAD - Külföld
 */
export type WineRegion = 'HUNGARY' | 'ABROAD';

export const WineRegion = {
  Hungary: 'HUNGARY' as WineRegion,
  Abroad: 'ABROAD' as WineRegion,
};
